'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIMedia;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _MediaConstants = require('./MediaConstants');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function UIMedia(props) {
  var align = props.align,
      children = props.children,
      className = props.className,
      collapsed = props.collapsed,
      spacing = props.spacing,
      rest = _objectWithoutProperties(props, ['align', 'children', 'className', 'collapsed', 'spacing']);

  if (collapsed) {
    _devLogger2.default.warn({
      message: 'UIMedia: the `collapsed` prop is deprecated in favor of ' + '`spacing="none"` and may be removed in the future.',
      key: 'UIMedia: collapsed prop deprecated'
    });
  }

  return _react2.default.createElement(
    'div',
    _extends({}, rest, {
      className: (0, _classNames2.default)('media', 'private-media', _MediaConstants.MEDIA_ALIGNMENT_TYPES[align], _MediaConstants.MEDIA_SPACING[spacing], { 'private-media--collapsed': collapsed }, className)
    }),
    children
  );
}

UIMedia.displayName = 'UIMedia';

UIMedia.propTypes = {
  align: _react.PropTypes.oneOf(Object.keys(_MediaConstants.MEDIA_ALIGNMENT_TYPES)),
  children: _react.PropTypes.node.isRequired,
  className: _react.PropTypes.string,
  collapsed: _react.PropTypes.bool.isRequired,
  spacing: _react.PropTypes.oneOf(Object.keys(_MediaConstants.MEDIA_SPACING)).isRequired
};

UIMedia.defaultProps = {
  collapsed: false,
  spacing: 'small'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/layout/UIMedia.js
// module id = 532
// module chunks = 2 3